export default __webpack_public_path__ + "c4248615291a9e8f1fb7004c57ba6b24.woff";